import { HeaderOptions } from '../../base/interfaces/headerInterface';
import { headerOptionsSlice } from '../reducers/headerOptionsSlice';
import { getStore } from '../store';

type headerOptionsActionType = 'headerOptions/setHeaderOptions';

export const headerOptionsProvider = (): {
  setHeaderOptions: (headerOptions: HeaderOptions) => { payload: HeaderOptions; type: headerOptionsActionType };
} => {
  const { dispatch } = getStore();
  const { setHeaderOptions } = headerOptionsSlice.actions;
  return {
    setHeaderOptions: (headerOptions: HeaderOptions): { payload: HeaderOptions; type: headerOptionsActionType } =>
      dispatch(setHeaderOptions(headerOptions)),
  };
};
